import styled from "styled-components";
import { EmbedTheme } from "../../utils/embeds";
import { V3Body, V3Caption, V3HeadlineH3 } from "../Typography";
import { ClampMixin, ClampMixinType } from "../ReusableStyledComponents/ClampMixin";

export type EmbedWithClamp = { $embedTheme: EmbedTheme } & ClampMixinType;

export const V3EmbedCollBody = styled(V3Body) <EmbedWithClamp>`
    color: ${({ $embedTheme, theme }) => $embedTheme === EmbedTheme.dark ? theme.v3.colors.grey70 : theme.v3.colors.grey48};
    ${ClampMixin};
`;

export const V3EmbedCollectionTitle = styled(V3HeadlineH3) <EmbedWithClamp>`
    color: ${({ $embedTheme }) => $embedTheme === EmbedTheme.dark ? "white" : undefined};
    font-size: 24px;
    line-height: 30px;
    ${ClampMixin};
`;

export const V3EmbedCollectionDesc = styled(V3Caption) <EmbedWithClamp>`
    color: ${({ $embedTheme, theme }) => $embedTheme === EmbedTheme.dark ? theme.v3.colors.grey70 : theme.v3.colors.grey48};
    ${ClampMixin};
`;

export const V3EmbedCollectionSeparator = styled.hr`
    background: ${({ theme }) => theme ? theme.v3.colors.grey88 : null};
    height: 1px;
    border: 0;
    margin: 0;
`;